<div class="col-12">
    <div class="border-bottom-1 surface-border">
        <p>
          Hi, you have resume/certifications on your another firm. Would you like to add them in this firm?
      </p>
      <div class="col-12 lg:col-12 xl:lg:col-12 mb-3 align-items-center">
        <p-button
            class="col-12 lg:col-12 xl:lg:col-12"
            [rounded]="true"
            (click)="cancel()" label="no"></p-button>
        <p-button
            class="col-12 lg:col-12 xl:lg:col-12"
            (click)="submit()"
            [rounded]="true"
            styleClass="freshgreen-background" label="yes"></p-button>
    </div>
    </div>
</div>
  